import { v4 as uuidv4 } from "uuid";

export function createMarkup(html) {
	return { __html: html };
}

export const getBase64 = (file) => {
	return new Promise((resolve) => {
		// Make new FileReader
		let reader = new FileReader();

		// on reader load somthing...
		reader.onload = () => {
			// Make a fileInfo Object
			resolve(reader.result);
		};
		// Convert the file to base64 text
		reader.readAsDataURL(file);
	});
};

export const newId = () => uuidv4();

export const getQueryValue = (name) => {
	let search = window.location.search;
	let params = new URLSearchParams(search);
	return params.get(name);
};

export const ciEquals = (a, b) => {
	return typeof a === "string" && typeof b === "string"
		? a.localeCompare(b, undefined, { sensitivity: "base" }) === 0
		: a === b;
};

//validation helper - todo: refactor
export const validator = (validation, value) => {
	if (!validation || validation.length === 0) return;
	switch (validation.type) {
		case "mandatory":
			if (
				typeof value === "undefined" ||
				value?.length === 0 ||
				value === null
			) {
				return {
					validationType: validation.type,
					message: `This response is mandatory`,
				};
			}
			break;
		case "maxLength":
			if (value && value.length > validation.value) {
				return {
					validationType: validation.type,
					message: `This response can't exceed the maximum length of ${validation.value} letters.`,
				};
			}
			break;

		case "integer":
			if (!Number.isInteger(value)) {
				return {
					validationType: validation.type,
					message: `This response should be a number without any decimal points.`,
				};
			}
			break;
		case "number":
			if (isNaN(value)) {
				return {
					validationType: validation.type,
					message: `This response should be a number.`,
				};
			}
			break;
		case "minValue":
			if (value && value < validation.value) {
				return {
					validationType: validation.type,
					message: `This response cannot be less than ${validation.value}`,
				};
			}
			break;
		case "numericValue2dp":
			if (
				value &&
				Math.abs(value).toFixed(2) !== validation.value.toFixed(2)
			) {
				return {
					validationType: validation.type,
					message: `This response must be ${validation.value}`,
				};
			}
			break;
		default:
			break;
	}
};

export const arrayFromSize = (length) => {
	return Array.from({ length }, (_, k) => k);
};

export const downloadFile = (doc) => {
	const blob = b64toBlob(doc);
	const link = document.createElement("a");

	//for IE use proprietary blob saving function
	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		window.navigator.msSaveOrOpenBlob(blob, doc.fileName);
	} else {
		//other browsers
		link.href = window.URL.createObjectURL(blob);
		link.download = doc.fileName;
		link.click();
	}
};

export const getFile = (doc) => {
	const blob = b64toBlob(doc);
	return URL.createObjectURL(blob);
};

function b64toBlob(doc) {
	var byteString = atob(
		doc.fileContent.indexOf(",") < 0
			? doc.fileContent
			: doc.fileContent.split(",")[1]
	);
	var ab = new ArrayBuffer(byteString.length);
	var ia = new Uint8Array(ab);
	for (var i = 0; i < byteString.length; i++) {
		ia[i] = byteString.charCodeAt(i);
	}
	return new Blob([ab], { type: doc.fileType });
}

export function getPropertyCi(object, key) {
	return object[
		Object.keys(object).find((k) => k.toLowerCase() === key.toLowerCase())
	];
}

function getAnyValueForSorting(value) {
	if (typeof value === "string") return value.toLowerCase();
	else return value;
}

export function sortAnyValue(a, b, sortDirection) {
	const valueA = getAnyValueForSorting(a);
	const valueB = getAnyValueForSorting(b);

	//equal items sort equally
	if (valueA === valueB) {
		return 0;
	}
	//sort nulls last before anything else
	if (valueA === null) {
		return 1;
	}
	if (valueB === null) {
		return -1;
	}
	//otherwise if ascending, lowest sorts first
	if (sortDirection === "asc") {
		return valueA < valueB ? -1 : 1;
	}
	//if descending, highest sorts first
	if (sortDirection === "desc") {
		return valueA > valueB ? -1 : 1;
	}
}

export function sortByMultipleProperties(...properties) {
	return (a, b) => {
		for (const prop of properties) {
			const [key, order = "asc"] = Array.isArray(prop) ? prop : [prop];

			let comparison = 0;
			if (a[key] < b[key]) comparison = -1;
			if (a[key] > b[key]) comparison = 1;

			if (comparison !== 0) {
				return order === "desc" ? -comparison : comparison;
			}
		}
		return 0;
	};
}

export function getTimezone() {
	if (process.env.REACT_APP_TIMEZONE === "NZDT") return "NZDT";
	else return "UTC";
}

export function getFormattedNumber(value) {
	if (!value) return value;
	var parts = value.toString().split(".");
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	return parts.join(".");
}
